import moment from 'moment'
import 'moment/locale/pt-br'

export default {
  resetPedidos (state) {
    state.pedidosReport = []
  },
  setPedidos (state, value) {
    let totalPrice = 0
    let result = value.reduce((res, obj) => {
      let price = 0
      let qtde = 0
      let items = obj.itens.map(elem => {
        price += (elem.count * elem.price)
        qtde++
        return elem.name
      })
      items = items.join(', ')
      totalPrice += price
      if (typeof price !== 'number') price = 0
      price = price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      var newItem = {
        data: moment(obj.date).format('DD/MM/YYYY HH:mm'),
        nro: obj.identifier,
        itens: items,
        qtd: qtde,
        fornecedor: obj.fornecedorNome,
        condominio: obj.condominium.name,
        adm: obj.condominium.administrator,
        morador: obj.client,
        email: obj.email,
        phone: obj.phone,
        unidade: obj.unit,
        valor: price
      }
      res.push(newItem)
      return res
    }, [])
    totalPrice = totalPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    var newItem = {
      data: '',
      nro: '',
      itens: '',
      qtd: '',
      fornecedor: '',
      morador: '',
      email: '',
      phone: '',
      unidade: 'TOTAL',
      valor: totalPrice
    }
    result.push(newItem)
    result.sort((a, b) => {
      var keyA = new Date(a.data)
      var keyB = new Date(b.data)
      if (keyA < keyB) return -1
      if (keyA > keyB) return 1
      return 0
    })
    state.pedidosReport = result
  },
  setStatus (state, value) {
    state.statusOrder = value
  },
  setFornecedores (state, value) {
    state.business = value
  }
}



// WEBPACK FOOTER //
// ./src/store/relatorios/mutations.js